import { render, staticRenderFns } from "./StockFlowReportCard.vue?vue&type=template&id=039f7cf4&"
import script from "./StockFlowReportCard.vue?vue&type=script&lang=ts&"
export * from "./StockFlowReportCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports